import React from "react";
import ReactApexChart from "react-apexcharts";
import { fontFamilies } from "theme/fontConfig";
import { Box, Typography, IconButton } from "@material-ui/core";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// direct import
import { useStyles } from "./style";

const Profile = ({ profile, title, handleClick }) => {
  const classes = useStyles();

  const radialChart = {
    series: [profile],
    options: {
      chart: {
        type: "radialBar",
        sparkline: { enabled: true },
        // ApexCharts uses Helvetica by default; use the app font
        fontFamily: fontFamilies.primary,
      },
      plotOptions: {
        radialBar: {
          startAngle: 0,
          endAngle: 360,
          hollow: {
            margin: 0,
            size: "65%",
            background: "transparent",
          },
          track: {
            background: "#E5EAF2",
            strokeWidth: "100%",
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: true,
              fontSize: "16px",
              fontWeight: 600,
              fontFamily: fontFamilies.primary,
              color: "#464E5F",
              offsetY: 5,
              formatter: () => `${profile}%`,
            },
          },
        },
      },
      fill: {
        type: "solid",
        colors: ["#2555EF"],
      },
      stroke: {
        lineCap: "round",
      },
      labels: [""],
    },
  };

  return (
    <Box className={classes.container} onClick={handleClick}>
      <Box className={classes.chartWrapper}>
        <ReactApexChart
          options={radialChart.options}
          series={radialChart.series}
          type="radialBar"
          width={100}
          height={100}
        />
      </Box>
      <Box>
        <Typography className={classes.title}>
          {title ? title : "Profile"} Completion
        </Typography>
        <Typography className={classes.subtitle}>
          Complete Profile Details
        </Typography>
      </Box>
      <Box sx={{ ml: "auto" }}>
        <IconButton>
          <ChevronRightIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Profile;
